<template>
  <div class="box">
    <div class="xcx">
      <div>小程序发布岗位</div>
      <img src="../../../assets/img/qxiaoyunxcx.jpg" alt />
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="岗位类型">
        <el-select v-model="formInline.job_type" clearable placeholder="请选择岗位类型">
          <el-option v-for="item in $store.state.jobTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">查询</el-button>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()">发布岗位</el-button>
        <el-button type="primary" @click="addDouble()">发布双选会岗位</el-button>
        <span class="info">该岗位直接发布给您已认证合作的学校，认证审核通过后学校平台自动推送给全校学生，岗位可信度高，学生投递更放心！</span>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" id="table">
      <el-table-column fixed prop="created_at" label="发布时间" min-width="100px" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="job_name" label="岗位名称" show-overflow-tooltip></el-table-column>
      <el-table-column label="总投递" prop="apply_count"></el-table-column>
      <el-table-column prop="recruitment" label="招聘人数"></el-table-column>
      <!-- <el-table-column prop="school_name" label="合作学校" min-width="100px" show-overflow-tooltip></el-table-column> -->
      <el-table-column label="到期时间" min-width="100px" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.due_time">{{scope.row.due_time}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="岗位类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type=='qxiaoyun'">企校云</span>
          <span v-if="scope.row.type=='sxh'">双选会</span>
          <span v-if="scope.row.type=='sxsq'">实习申请</span>
          <span v-if="scope.row.type=='top'">置顶</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="上线状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status=='valid' || scope.row.status=='online'" style="color:#67C23A;">已上线</span>
          <span v-else-if="scope.row.status=='offline'" style="color:#F56C6C;">已下线</span>
          <el-tooltip class="item" effect="dark" content="联系管理员快速审核" placement="top" v-else-if="scope.row.status=='no_audit'">
            <span style="color:#F56C6C; font-weight:bold">待审核</span>
          </el-tooltip>
          <span v-else-if="scope.row.status=='refused'" style="color:#F56C6C;">被驳回</span>
          <span v-else-if="scope.row.status=='invalid'" style="color:red;font-weight:bold;">未上线</span>
          <span v-else style="color:red;">未上线</span>
        </template>
      </el-table-column>
      <el-table-column prop="pay_status" label="认证状态">
        <template slot-scope="scope">
          <span v-if="scope.row.pay_status=='no_paid'" style="color:#F56C6C;">未认证</span>
          <span v-if="scope.row.pay_status=='paid' " style="color:#67C23A;">已认证</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="valid(scope.row)">上线</el-button>
          <el-button size="mini" type="info" @click="offline(scope.row.id)">下线</el-button>
          <!-- <el-button size="mini" type="success" @click="valid(scope.row)" v-if="contact_school!='46'">上线</el-button>
          <el-button size="mini" type="info" @click="offline(scope.row.id)" v-if="contact_school!='46'">下线</el-button> -->
          <!-- <el-button size="mini" type="success" @click="other(scope.row)">发布到其他学校</el-button> -->
          <el-button size="mini" type="primary" @click="read(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="update(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="pagination" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 查看弹窗框 -->
    <el-dialog :visible.sync="dialogVisible" width="500px" :append-to-body="true">
      <el-row v-for="item in dialog" :key="item.key">
        <div v-if="item.key == 'job_detail'">
          <el-col :span="6">
            <div style="text-align: right;">{{ item.name }}</div>
          </el-col>
          <el-col :span="12">
            <div v-html="item.value"></div>
          </el-col>
        </div>
        <div v-else>
          <el-col :span="6">
            <div style="text-align: right;">{{ item.name }}</div>
          </el-col>
          <el-col :span="12">
            <div>{{ item.value }}</div>
          </el-col>
        </div>
      </el-row>
    </el-dialog>

    <!-- 选择发布时长弹出框 -->
    <el-dialog title="请进行岗位发布认证" :visible.sync="dialogFormVisible2" width="500px">
      <div class="infoText">当前岗位发布需认证付费，请选择您要发布的岗位有效月份数，并完成付费认证，即可开启招聘！付费后您的岗位排名TOP10%！</div>
      <el-form>
        <div v-if="isArray">
          <el-radio v-model="monthRadio" :label="firstPay" v-if="firstPay">使用岗位次数抵扣，当前剩余{{firstPay.value}}个</el-radio>
          <br />
          <br />
          <el-radio v-model="monthRadio" :label="payInfo[0]">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1]">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2]">{{payInfo[2].value}}元/3个月</el-radio>
          <!-- <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>-->
          <!-- <el-radio v-model="monthRadio" :label="firstPay.code" v-if='firstPay'>使用岗位次数抵扣，当前剩余{{firstPay.value}}个</el-radio>
           <br><br>
          <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>-->
        </div>
        <div v-else>
          <el-radio v-model="monthRadio" :label="payInfo">{{payInfo.value}}元/年</el-radio>
        </div>
      </el-form>
      <div class="red">平台建议：岗位有效期越久排名越靠前，平台投递人数会更多</div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible2 = false">取 消</el-button> -->
        <el-button @click="cancelChoose()">取 消</el-button>
        <el-button type="primary" @click="chooseMonth()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 选择发布时长弹出框 -->
    <el-dialog title="学校发布付费认证" :visible.sync="dialogFormVisible3" width="500px">
      <div class="infoText">该岗位发布到其他学校，需要进行付费认证，认证后才可直接发布到学校后台。请尽快完成付费认证！</div>
      <el-form>
        <div v-if="isArray">
          <el-radio v-model="monthRadio" :label="firstPay" v-if="firstPay">使用岗位次数抵扣，当前剩余{{firstPay.value}}个</el-radio>
          <br />
          <br />
          <el-radio v-model="monthRadio" :label="payInfo[0]">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1]">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2]">{{payInfo[2].value}}元/3个月</el-radio>
          <!-- <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>-->
          <!-- <el-radio v-model="monthRadio" :label="firstPay.code" v-if='firstPay'>使用岗位次数抵扣，当前剩余{{firstPay.value}}个</el-radio>
           <br><br>
          <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>-->
        </div>
        <div v-else>
          <el-radio v-model="monthRadio" :label="payInfo">{{payInfo.value}}元/年</el-radio>
        </div>
      </el-form>
      <div class="red">平台建议：岗位有效期越久排名越靠前，平台投递人数会更多</div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible2 = false">取 消</el-button> -->
        <el-button @click="cancelChoose2()">取 消</el-button>
        <el-button type="primary" @click="chooseMonth2()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 根据省份选学校 -->
    <el-dialog title="请先选择一所学校" :visible.sync="chooseSchoolDialog" width="800px" class="chooseSchool">
      <div class="allProvince">
        <span v-for="(item,index) in allSchool" :key="index" class="item" :class="{ active:index===number}" @click="chooseProv(index,item)">{{item.province}}</span>
      </div>
      <div class="inputSchool">
        <el-input placeholder="请输入内容" style="width:300px" v-model="schoolName" @input="searchSchool"></el-input>
        <span style="color:red;margin-left:10px" v-if="schoolList2.length == 0">未搜索到学校</span>
      </div>
      <div class="schoolList">
        <div class="line" v-for="(item,index) in schoolList2" :key="index" @click="chooseSchool(item.school_id)">
          <div class="schoolName">{{item.school_name}}</div>
          <div class="count">
            <span>平台学生数量</span>
            <span class="fontColor">{{item.current_student_num}}</span>人
            <span style="margin-left:20px">专业</span>
            <span class="fontColor">{{item.major_num}}</span>个
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseSchoolDialog = false">取 消</el-button>
        <!-- <el-button type="primary" @click="chooseSchoolDialog = false">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import baseUrl from '@/api/baseUrl.js';
import qs from 'qs';
import formatter from '@/assets/js/mixins/formatter';
import Pagination from '@/components/pagination'; // 分页组件

export default {
  mixins: [formatter],
  components: {
    Pagination,
  },
  data() {
    return {
      contact_school: '',
      formInline: {
        jobTypes: '',
      },
      // 分页
      total: 0, // 总数
      page: 1, // 当前页
      page_size: 10, // 每页条数
      tableData: [],
      //弹出框
      dialogVisible: false,
      dialog: [
        {
          name: '发布时间：',
          key: 'created_at',
          value: '',
        },
        {
          name: '岗位：',
          key: 'job_name',
          value: '',
        },
        {
          name: '岗位类型：',
          key: 'job_type',
          value: '',
        },
        {
          name: '学历要求：',
          key: 'education',
          value: '',
        },
        {
          name: '年龄要求：',
          key: 'age_require',
          value: '',
        },
        // {
        //   name: '岗位诱惑：',
        //   key: 'job_attraction',
        //   value: '',
        // },
        // {
        //   name: '截止时间：',
        //   key: 'end_time',
        //   value: '',
        // },
        {
          name: "联系人：",
          key: "contact",
          value: ""
        },
        {
          name: "电话：",
          key: "telephone",
          value: ""
        },
        // {
        //   name: "email：",
        //   key: "email",
        //   value: ""
        // },

        {
          name: '岗位描述：',
          key: 'job_detail',
          value: '',
        },
        // {
        //   name: "岗位要求：",
        //   key: "request",
        //   value: ""
        // },
        {
          name: '招聘人数：',
          key: 'recruitment',
          value: '',
        },
        {
          name: '岗位待遇：',
          key: 'salary',
          value: '',
        },
        {
          name: '食宿安排：',
          key: 'food_bed_str',
          value: '',
        },
        {
          name: '详细地址：',
          key: 'job_address',
          value: '',
        },
        // {
        //   name: "对口专业：",
        //   key: "expect_major",
        //   value: ""
        // }
      ],
      channel: '',
      schools: '',
      schoolId: '',
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      monthRadio: null, // 付费单选按钮的值
      isArray: true, // 判断payInfo是数组还是对象
      pay_jobId: '',
      payInfo: [
        { code: 0, value: 0 },
        { code: 0, value: 0 },
        { code: 0, value: 0 },
      ],
      firstPay: null,
      chooseSchoolDialog: false,
      allSchool: [],
      allSchoolList: [],
      schoolList: [],
      schoolList2: [],
      // allProvince: ["全部"],
      number: 0,
      schoolName: '',
      addJobParams: {},
    };
  },
  mounted() {
    // this.getPayInfo();
    this.getSchooldId();
    this.getList();
    this.getAllSchool();
  },
  methods: {
    //获取列表
    async getList() {
      let params = {
        page: this.page,
        page_size: this.page_size,
        job_type: this.formInline.job_type,
        // start: this.formInline.time[0],
        // end: this.formInline.time[1],
        // e_name: this.formInline.e_name
        // status: "valid"
      };
      let res = await this.$api.job.getJobList(params);
      if (res.code === 0) {
        if (res.data.items) {
          this.tableData = res.data.items;
          this.total = res.data.count;
        }
      }
    },
    getSchooldId() {
      this.contact_school = localStorage.getItem('contact_school');
    },
    // 查看岗位详情
    read(row) {
      this.dialogVisible = true;
      let dialog = this.dialog;

      for (let item of dialog) {
        if (item.key != 'salary') {
          item.value = row[item.key];
        } else {
          console.log(row[item.key].indexOf('面议'));
          if (row[item.key].indexOf('面议') == -1) {
            item.value = row[item.key];
          } else {
            item.value = '面议';
          }
        }
      }

      this.channel = '';
      if (row.type) {
        for (let item of row.type) {
          switch (item.type) {
            case 'xcx':
              this.channel += '小程序，';
              break;
            case 'woa':
              this.channel += '公众号，';
              break;
            case 'school':
              this.channel = this.channel + item.school_name + '，';
              break;
          }
        }
      }
    },
    //查询
    // onSubmit() {
    //   this.getList();
    // },
    async getPayInfo(schoolId) {
      this.monthRadio = null;
      let res = await this.$api.pay.getEnterpriseJobFee({
        school_id: schoolId,
      });

      if (res.code == 0) {
        this.payInfo = res.data;
        if (Array.isArray(res.data)) {
          this.isArray = true;
          this.payInfo.forEach((item, index) => {
            if (item.id == 222) {
              this.firstPay = item;
              this.payInfo.splice(index, 1);
            }
          });
        } else {
          this.isArray = false;
          this.monthRadio = res.data;
        }
      }
    },
    // 获取所有学校
    getAllSchool() {
      var data1 = JSON.parse(localStorage.getItem('qxySchool'));
      let schoolObj = data1;
      let schoolArr = [];
      for (var key in schoolObj) {
        schoolArr.push(schoolObj[key]);
      }
      schoolArr.unshift({ province: '全部', items: [] });
      this.allSchool = schoolArr;
      schoolArr.forEach((item, index) => {
        this.allSchoolList = this.allSchoolList.concat(item.items);
        this.schoolList = this.allSchoolList;
        this.schoolList2 = this.allSchoolList;
      });

      // let res = await this.$api.school.getAllSchool();
      // if (res.code == 0) {
      //   let schoolObj = res.data;
      //   let schoolArr = [];
      //   for (var key in schoolObj) {
      //     schoolArr.push(schoolObj[key]);
      //   }
      //   schoolArr.unshift({ province: "全部", items: [] });
      //   this.allSchool = schoolArr;
      //   schoolArr.forEach((item, index) => {
      //     this.allSchoolList = this.allSchoolList.concat(item.items);
      //     this.schoolList = this.allSchoolList;
      //     this.schoolList2 = this.allSchoolList;
      //   });
      // }
    },
    // 取消付费
    cancelChoose() {
      this.dialogFormVisible2 = false;
      this.getList();
    },
    cancelChoose2() {
      this.dialogFormVisible3 = false;
      this.getList();
    },
    chooseProv(index, item) {
      this.number = index;
      if (index == 0) {
        this.schoolList = this.allSchoolList;
        this.schoolList2 = this.schoolList;
      } else {
        this.schoolList = item.items;
        this.schoolList2 = this.schoolList;
      }
    },
    searchSchool(val) {
      this.schoolList2 = [];
      this.schoolList.forEach((item) => {
        if (item.school_name.indexOf(val) != -1) {
          this.schoolList2.push(item);
        }
      });
    },
    // 选择学校后发布岗位
    async chooseSchool(schoolId) {
      if (!schoolId) {
        this.$message({
          message: '你还没有选择学校',
          type: 'warning',
        });
        return;
      }
      this.schoolId = schoolId;
      this.addJobParams.school_id = schoolId;

      this.chooseSchoolDialog = false;

      let params = this.delNullVal(this.addJobParams);

      // 调用添加岗位接口
      let res = await this.$api.job.addSchoolJob(params);
      if (res.code === 0) {
        let jobId = res.data.id;
        this.pay_jobId = jobId;
        // 判断是否需要跳转付费界面
        let requirePay = res.data.requirePay;
        if (requirePay == 'yes') {
          this.getPayInfo(schoolId);
          // 显示选择发布时长并跳转付费页面对话框
          this.dialogFormVisible3 = true;
        } else if (requirePay == 'no') {
          this.$confirm('岗位发布成功，联系管理员快速审核', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          })
            .then(() => {
              this.getList();
            })
            .catch(() => {
              this.getList();
            });
        }
      }
    },
    // 发布岗位
    async add() {
      // 跳转到添加岗位页面
      this.$router.push({
        path: '/addSchoolJob',
        query: {
          operate: 'add',
        },
      });
    },
    // 发布岗位
    async addDouble() {
      // 跳转到添加岗位页面
      this.$router.push({
        path: '/addDouSchoolJob',
        query: {
          operate: 'add',
        },
      });
    },
    addJob() {
      if (!this.schoolId) {
        this.$message({
          message: '你还没有选择学校',
          type: 'warning',
        });
        return;
      }

      // 跳转到添加岗位页面
      this.$router.push({
        path: '/addSchoolJob',
        query: {
          operate: 'add',
          schoolId: this.schoolId,
        },
      });
    },
    update(row) {
      localStorage.setItem('job', JSON.stringify(row));
      this.$router.push({
        path: '/addSchoolJob',
        query: {
          operate: 'update',
        },
      });
    },
    other(row) {
      let params = {
        school_id: '',
        job_name: row.job_name, //岗位
        province_id: row.province_id,
        city_id: row.city_id,
        province: row.province,
        city: row.city,
        age_require: row.age_require,
        job_address: row.job_address, //岗位详细地址
        job_detail: row.job_detail, //岗位描述
        job_attraction: row.job_attraction, //岗位吸引力
        recruitment: row.recruitment, //招聘人数
        salary_start: row.salary_start,
        salary_end: row.salary_end,
        salary: row.salary, //岗位待遇
        food_bed: row.food_bed_id, //食宿安排情况
        end_time: row.end_time, //截止时间
        job_type: row.job_type, // 岗位类型
        education: row.education, // 学历要求
      };
      // console.log(params);
      this.addJobParams = params;
      this.chooseSchoolDialog = true;
      return;
      // localStorage.setItem("job", JSON.stringify(row));
      // this.$router.push({
      //   path: "/addSchoolJob",
      //   query: {
      //     operate: "other"
      //   }
      // });
    },
    async delConfirm(jobId) {
      let res = await this.$api.job.delJob(jobId);
      if (res.code === 0) {
        this.$message.success('删除成功！');
        this.getList();
      }
    },
    del(row) {
      this.$confirm('确认删除该职位?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.delConfirm(row.id);
      });
    },
    chooseMonth() {
      if (!this.monthRadio) {
        this.$message('请选择一个付费项目');
        return;
      }
      this.dialogFormVisible2 = false;
      console.log(this.monthRadio);
      console.log(this.monthRadio.code);
      console.log(this.monthRadio.type);
      this.payJobFee(this.pay_jobId, this.schoolId, this.monthRadio.code, this.monthRadio.type);
    },
    chooseMonth2() {
      if (!this.monthRadio) {
        this.$message('请选择一个付费项目');
        return;
      }
      this.dialogFormVisible3 = false;
      console.log(this.monthRadio.code);
      console.log(this.monthRadio.type);
      this.payJobFee(this.pay_jobId, this.schoolId, this.monthRadio.code, this.monthRadio.type);
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    offline(jobId) {
      this.$confirm('确定下线该岗位？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$api.job
          .updateJob(jobId, {
            status: 'offline',
          })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功！');
              this.getList();
            }
          });
      });
    },
    toPay(jobId, schoolId) {
      this.pay_jobId = jobId;
      this.schoolId = schoolId;
      this.dialogFormVisible2 = true;
    },
    // 上线操作先判断是否付过费
    valid(job) {
      this.$confirm('确定上线该岗位？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // 以前的逻辑，不判断付费
        // this.$api.job
        //   .updateJob(job.id, {
        //     status: "valid"
        //   })
        //   .then(res => {
        //     if (res.code === 0) {
        //       this.$message.success("操作成功！");
        //       this.getList();
        //     }
        //   });

        // 判断岗位是否付费，未付费需要先付费
        // if (job.pay_status == "paid") {
        this.$api.job
          .updateJob(job.id, {
            status: 'valid',
          })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功！');
              this.getList();
            }
          });
        // } else {
        //   // console.log(this.getPayInfo(job.school_id))
        //   this.getPayInfo(job.school_id);
        //   this.pay_jobId = job.id;
        //   this.schoolId = job.school_id;
        //   this.dialogFormVisible2 = true;
        // }
      });
    },
    payJobFee(jobId, schoolId, month, sys_conf_type) {
      let params = {
        subject: '校企合作岗位服务费',
        type: 'web',
        school_id: schoolId,
        // school_id: schoolId,
        job_id: jobId,
        fee_type: month,
        sys_conf_type: sys_conf_type,
      };
      axios
        .post(baseUrl + 'api/enterprise/pay/enterprise_job/alipay/index', qs.stringify(params), {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement('div');
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[2].acceptCharset = 'GBK'; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[2].submit();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
  .info {
    color: red;
    margin-left: 15px;
  }
}
.cell {
  .el-button {
    margin-left: 5px;
    margin-top: 3px;
  }
}
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 5px 20px;
    .infoText {
      color: orange;
      margin-bottom: 20px;
    }
    .red {
      color: red;
      margin-top: 20px;
    }
  }
}
/deep/ .chooseSchool {
  .el-dialog__body {
    padding: 0px 20px;
    .allProvince {
      .item {
        display: inline-block;
        margin: 0px 8px;
        padding: 5px;
        cursor: pointer;
      }
      .active {
        background: cyan;
      }
    }
    .inputSchool {
      padding-left: 10px;
      margin-top: 10px;
    }
    .schoolList {
      height: 350px;
      margin: 10px;
      padding: 5px;
      border: 1px solid #dcdcdc;
      overflow: auto;
      .line {
        padding: 8px 2px;
        cursor: pointer;
        .schoolName {
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 8px;
        }
        .count {
          font-weight: initial;
          .fontColor {
            color: #ec6941;
          }
        }
      }
      .line:hover {
        background: #dcdcdc;
      }
    }
  }
}
.xcx {
  position: absolute;
  top: 5px;
  right: 50px;
  text-align: center;
  font-size: 12px;
  color: red;
  font-weight: bold;
  img {
    width: 100px;
  }
}
</style>
